import {
  Skeleton,
  type SkeletonProps,
  Stack,
  type StackProps,
} from '@mantine/core'
import { range } from 'lodash'

type LoadingSkeletonProps = {
  maxRange: number
  stackProps?: StackProps
} & SkeletonProps

const LoadingSkeleton = ({
  maxRange,
  stackProps,
  ...props
}: LoadingSkeletonProps) => {
  return (
    <Stack {...stackProps}>
      {range(0, maxRange).map((row) => (
        <Skeleton key={row} {...props} />
      ))}
    </Stack>
  )
}

export default LoadingSkeleton
